const { http, HttpResponse } = window.MockServiceWorker;
import { umbMemberTypeMockDb } from '../../db/member-type.db.js';
import { UMB_SLUG } from './slug.js';
import { umbracoPath } from '@umbraco-cms/backoffice/utils';

export const treeHandlers = [
	http.get(umbracoPath(`/tree${UMB_SLUG}/root`), ({ request }) => {
		const searchParams = new URL(request.url).searchParams;
		const skip = Number(searchParams.get('skip') ?? '0');
		const take = Number(searchParams.get('take') ?? '100');
		const response = umbMemberTypeMockDb.tree.getRoot({ skip, take });
		return HttpResponse.json(response);
	}),

	http.get(umbracoPath(`/tree${UMB_SLUG}/children`), ({ request }) => {
		const searchParams = new URL(request.url).searchParams;
		const parentId = searchParams.get('parentId');
		if (!parentId) return;
		const skip = Number(searchParams.get('skip') ?? '0');
		const take = Number(searchParams.get('take') ?? '100');
		const response = umbMemberTypeMockDb.tree.getChildrenOf({ parentId, skip, take });
		return HttpResponse.json(response);
	}),

	http.get(umbracoPath(`/tree${UMB_SLUG}/siblings`), ({ request }) => {
		const url = new URL(request.url);
		const targetId = url.searchParams.get('target');
		if (!targetId) return;
		const before = Number(url.searchParams.get('before'));
		const after = Number(url.searchParams.get('after'));
		const response = umbMemberTypeMockDb.tree.getSiblingsOf({ targetId, before, after });
		if (!response) return new HttpResponse(null, { status: 404, statusText: 'target not found' });
		return HttpResponse.json(response);
	}),
];
